import { IonButton, IonCol, IonImg, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup, IonRow, useIonViewDidEnter, IonGrid, IonPopover, IonContent, IonText, useIonViewWillEnter } from "@ionic/react";
import React, { useEffect, useState, useRef } from "react";
import PayComponent from "./PayComponent";
import { User } from "../models/data";
import { translation } from "../models/translation";
import { useExternalScript } from "../services/load_external_script";
import { createDonation, fetchUserBalance_b } from "../services/donate_service";
import { fetchPmtInitationData, upDatePaymentInfo } from "../services/pmt_service";
import UserTerms from "./UserTerms";
import { useHistory } from "react-router";
import { ymd } from "../utlities/ymd";

interface paymentObject {
    user: User,
    amount: number,
    type: string,
    donateData?: any,
    resetCredit?: any
}

type LanguageMap = {
    [key: string]: string;
};


const CreditPayV2: React.FC<paymentObject> = (props) => {

    const history = useHistory();

    useIonViewDidEnter(()=>{
        setOrg(props.donateData.pickOrg)
        setTip(props.donateData.tip)
        setAltOrg(props.donateData.altOrg)
    })

    useIonViewDidEnter(() => {
        if (props.type === "credit") {
            props.resetCredit();
        }
    })

    useIonViewDidEnter(() => {
        fetchCurrentUserBalance();
    })


    useEffect(() => {
        setAmount(props.amount);
        fetchCurrentUserBalance();
    }, [props.amount])

    const siteText = translation();

    const lan = translation().lan.replace("/", "");

    const languages: LanguageMap = {
        en: 'en-CH',
        fr: 'fr-CH',
        de: 'de-CH',
    }

    const tomorrow = new Date();

    tomorrow.setDate(new Date().getDate() + 1);

    const year = tomorrow.getFullYear();

    let month = `${tomorrow.getMonth() + 1}`;
    let day = `${tomorrow.getDate()}`;

    if (month.length < 2) { month = 0 + month };
    if (day.length < 2) { day = 0 + day };

    const minDate = `${year}-${month}-${day}`;

    const getLanguage = (lang: string) => {
        if (languages.hasOwnProperty(lang)) {
            return languages[lang]
        }
    }

    const pmtNotes = [{
        key: 'finance_C',
        notes: siteText.donateDirectlyPayFeeTxt + '1.80% ',
        id: 97627,
        fee: 0.018
    },
    {
        key: 'finance_E',
        notes: siteText.donateDirectlyPayFeeTxt + '1.80% ',
        id: 97628,
        fee: 0.018
    },
    {
        key: 'finance_Pay',
        notes: siteText.donateDirectlyPayFeeTxt + '1.80% ',
        id: 193207,
        fee: 0.018
    },
    {
        key: 'creditcard',
        notes: siteText.donateDirectlyPayFeeTxt + '1.65%',
        id: 103396,
        fee: 0.0165
    },

    {
        key: 'twint',
        notes: siteText.donateDirectlyPayFeeTxt + '1.40%',
        id: 99165,
        fee: 0.014
    },
    {
        key: 'invoice',
        notes: siteText.donateDirectlyPayFeeTxt + '0.0%',
        id: 103397,
        fee: 0.00
    },
    {
        key: siteText.donateUseMyCreditPayMethodNameTxt,
        notes: siteText.donateUseMyCreditPayFeeTxt + '0.0%',
        id: 100000,
        fee: 0.00
    }
    ]

    const [date] = useState<any>(minDate)
    const [org,setOrg]=useState<any>()
    const [altOrg,setAltOrg]=useState<any>()
    const [tip,setTip]=useState<any>()
    const [disabled, setDisabled] = useState<boolean>(false);
    const [isProcesseng, setIsProcessing] = useState<string>()
    const [balance, setBalance] = useState<number>(0);
    const [amount, setAmount] = useState<number>();
    const defalutCommission = 0.01;
    const [iframeUrl, setIframeUrl] = useState();
    const [paymentMethods, setPaymentMethods] = useState<any>();
    const [chosenMethod, setChosenMethod] = useState<any>();
    const [transactionId, setTransactionId] = useState<any>();
    const [version, setVersion] = useState<any>();
    const [chosenMethodName, setChosenMethodName] = useState<any>();
    const [reloading, setRelaoding] = useState<boolean>(false);
    const [totalAmount, setTotalAmount] = useState<any>(() => {
        return (+props.amount)
    });
    const [fee, setFee] = useState<any>(0);

    const [userTerms, showUserTerms] = useState<boolean>(false);
    const popover = useRef<HTMLIonPopoverElement>(null);
    const [popoverOpen, setPopoverOpen] = useState(false);


    //initialize state to null
    let state = '';


    /** */
    const fetchCurrentUserBalance = async () => {

        await fetchUserBalance_b(props.user.id).then(
            m => {
                if (!m?.error) {
                    setBalance(m?.message)
                }
            }
        );

    }

    //wait for component ready
    useEffect(() => {
        console.table(props.donateData)
        let mounted = true;
        fetchPmtInitationData(props.user, totalAmount, props.type, getLanguage(lan)).then(tools => {
            if (mounted) {
                if (!tools.error) {
                    let { jsUrl, pmtMtds, transactId, version } = tools.message
                    setIframeUrl(jsUrl);
                    setPaymentMethods(pmtMtds);
                    setTransactionId(transactId);
                    setVersion(version);
                }
            }

        })

        return () => {
            mounted = false;
        }

    },[props.type, props.amount,org,altOrg,tip])

    const updateTotalAmount = () => {
        setTotalAmount((+props.amount + (props.amount * fee)).toFixed(2))
    }

    useEffect(() => {
        updateTotalAmount();
    }, [fee, chosenMethod, props.amount]);


    useEffect(() => {
        let mounted = true;
        /*if (transactionId) { updatePayment(); }
        return () => {
            mounted = false;
        }*/
        if (chosenMethodName === 'sw_credit') {
            return
        }

        if (transactionId) {
            setRelaoding(true);
            upDatePaymentInfo(props.user, totalAmount, props.type, transactionId, version).then(
                m => {
                    //console.log(m);
                    if (mounted) {
                        if (!m.error) {
                            let newversion = m.message.version;
                            resetReloading(newversion);
                        }
                        return m;
                    }
                }
            )
        }
        return () => {
            mounted = false;
        }

    }, [chosenMethod])


    const resetReloading = (nversion: any) => {
        console.log(`nversion: ${nversion}`);
        setVersion(nversion);
        setRelaoding(false)
    }
    /**
     * Return the current state of the payment method script that is loaded external
     */
    state = useExternalScript(iframeUrl);

    /**
    * Choose amout text to show depending on the users current action
    * Checks the type prop value of the component
    * @returns amount text component
    */
    const AmountText = () => {
        if (props.type === 'credit') {
            return (
                <>{siteText.creditAccountPaymentTitle.replace('%%amount%%', '' + amount)}</>
            )
        } else {
            return (
                <>{siteText.donateDirectlyPayTitle.replace('%%amount%%', '' + amount)}</>
            )
        }
    }

    /**
     * Find the corresponding note for the current payment method in payment notes
     * @input :name  of the payment method
     * @returns: first corresponding method by name in payments notes

    */
    const getNotes = (id: number) => {
        let noteList = pmtNotes.filter((e, i, arr) => {
            if (e.id === id) return pmtNotes[i]
        })
        if (noteList.length > 0) {
            return noteList[0].notes
        }
        return '';
    }

    /**
     * Find the corresponding note for the current payment method in payment notes
     * @input :name  of the payment method
     * @returns: first corresponding method by name in payments notes

    */
    const getFee = (id: number) => {
        let noteList = pmtNotes.filter((e, i, arr) => {
            if (e.id === id) return pmtNotes[i]
        })
        if (noteList.length > 0) {
            return noteList[0].fee
        }
        return '';
    }

    const updateMethod = ({ value }: any) => {
        setChosenMethod(value.id);
        setFee(0);
        setChosenMethodName(value.name);
    }

    const completeDonation = () => {
        setPopoverOpen(false)
        setTimeout(() => {
            history.push(`/${lan}/account/start`)
        }, 30)
    }

    /*Close open user terms  */
    const toggleUserTerms = () => {
        let current = userTerms;
        showUserTerms(!current);
    }

    const onDonateWithCredit = (event: any) => {

        event.preventDefault();

        setDisabled(!disabled)
        setIsProcessing('processing')
        setPopoverOpen(true)

        createDonation({
            title: `${props.user.firstName}_on_${month}_${day} # ${Math.floor(Math.random() * 60)}`,
            status: "publish",
            acf: {
                status: "completed",
                beneficiary: props.donateData.pickOrg,
                alternative_benefiary: props.donateData.altOrg,
                beneficiary_type: props.donateData.beneficiary_type,
                anonymous: `${props.donateData.anom}`,
                amount: amount,
                tip: +props.donateData.tip,
                commission: 0,
                date: ymd(date.date),
                message: props.donateData.message,
                language: props.donateData.language ? props.donateData.language : '',
                donation_method: "sw_account",
                frequency: props.donateData.freq
            }
        }).then(m => {
            if (!m?.message) {
                setIsProcessing('error')
            } else {
                setIsProcessing('done')
            }
        })
    }

    return (
        <>
            {!userTerms ? <>
                <IonRow>
                    <IonCol>
                        <h1><AmountText /></h1>
                        <p>{siteText.donateDirectlyPayTotal.replace('%%amount%%', totalAmount)}</p>
                        <h3>{siteText.donateDirectlyPayMethodSelect}</h3>
                        <p> {siteText.donateDirectlyPayFeeNotice}</p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol sizeMd="8" >
                        <IonList>
                            <IonRadioGroup aria-disabled={reloading} onIonChange={e => { updateMethod(e.detail) }}>
                                {paymentMethods && paymentMethods.map((method: any, key: any) => {

                                    return (
                                        <IonItem key={key}>
                                            <IonImg className="ion-padding" style={{ maxWidth: "80px" }} src={method.image_url} slot="start"></IonImg>
                                            <IonLabel className="ion-text-wrap">
                                                {lan === "fr" && method.resolved_title["fr-FR"]}
                                                {lan === "de" && method.resolved_title["de-DE"]}
                                                {lan === "en" && method.resolved_title["en-US"]}
                                                {/*<br></br>
                                                <span className="pmt_notes">
                                                    {getNotes(method.id)}
                                    </span>*/}
                                            </IonLabel>
                                            <IonRadio value={{ id: method.id, fee: getFee(method.id), name: method.name }} disabled={reloading} />
                                        </IonItem>
                                    )
                                })}
                                {(state === "ready" && +balance < +totalAmount!) && <p><IonText color="medium" className="ion-margin-top">{siteText.donateUseCreditStartInsufficientCr}</IonText> </p>}
                                <IonItem fill={(+balance < +totalAmount!) ? 'outline' : 'solid'} lines={(+balance < +totalAmount!) ? 'none' : 'full'} className="ion-margin-top">
                                    <IonImg style={{ maxWidth: "80px" }} src={`${process.env.PUBLIC_URL}/assets/swissdonations_logo_01.png`} slot="start"></IonImg>

                                    <IonLabel className="ion-text-wrap">
                                        {pmtNotes.find((item) => item.id === 100000)?.key}
                                        <p>{siteText.donateUseCreditStartIndication.replace("%%amount%%", balance.toString())}</p>
                                        {/*<span className="pmt_notes">
                                            {getNotes(100000)}
                            </span>*/}
                                    </IonLabel>
                                    <IonRadio value={{ id: 100000, fee: getFee(100000), name: 'sw_credit' }} disabled={(reloading || +balance < +amount!)}></IonRadio>
                                </IonItem>
                            </IonRadioGroup>
                        </IonList>

                    </IonCol>
                </IonRow>

                <IonRow className={chosenMethod === 100000 ? 'ion-hide' : ''}>
                    <IonCol sizeMd="4">
                        <ul id="payment-errors"></ul>
                        <div id="payment-form"></div>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>

                        <div>
                            {state === "loading" && <p>...</p>}
                            <div style={{ display: 'inline' }} className={chosenMethod === 100000 ? 'ion-hide' : ''}>
                                {(state === "ready" && chosenMethod) ? <PayComponent siteText={siteText} totalAmount={totalAmount} user={props.user} amount={amount} method={chosenMethodName} commition={props.amount * defalutCommission} type={props.type} reloading={reloading} donateData={props.donateData} pmtMethod={chosenMethod} transactionId={transactionId} version={version} /> : <></>}
                            </div>
                            {(state !== "ready" || !chosenMethod) ? <IonButton disabled={true}><IonText color='light'>{props.type === "credit" ? siteText.creditAccountPaymentPrimary : siteText.donateDirectlypayPrimary}</IonText></IonButton> : ''}
                            {(state === "ready" && +balance < +totalAmount!) && <IonButton href={`/${lan}/account/credit`} fill='outline' color="secondary">{siteText.donateUseCreditAltTxt}</IonButton>}
                            {(state === 'ready' && chosenMethod === 100000) && <IonButton type="button" onClick={onDonateWithCredit}><IonText color="light">{siteText.donateUseCreditStartPrimaryTxt}</IonText></IonButton>}
                        </div>
                    </IonCol>
                </IonRow>
                <IonPopover ref={popover} isOpen={popoverOpen} backdropDismiss={false}>
                    <IonContent>
                        <IonGrid>
                            <IonRow className="ion-padding">
                                {isProcesseng === 'processing' &&
                                    <IonCol size="12">{siteText.donateUseCreditDetailsProcessing}</IonCol>}
                                {isProcesseng === 'done' && <IonCol size="12">
                                    <p>{siteText.donateUseCreditDetailsSuccess}
                                    </p>
                                    <IonButton color="success" onClick={completeDonation}> <IonText color="light">{siteText.donateUseCreditDetailsDoneString}</IonText> </IonButton>
                                </IonCol>}
                                {isProcesseng === 'error' && <IonCol size="12">
                                    <p>{siteText.donateUseCreditDetailsError}
                                    </p>
                                    <IonButton color="secondary" onClick={e => setPopoverOpen(false)}><IonText color="light">{siteText.donateUseCreditDetailsTryAgainString}</IonText> </IonButton>
                                </IonCol>}
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                </IonPopover>
            </> :
                <UserTerms goBack={toggleUserTerms}></UserTerms>}
        </>
    )
}


export default CreditPayV2;